import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./NearbyBenefits.css";

const CATEGORIES = [
  {
    id: "lounges",
    label: "Airport Lounges",
    emoji: "✈️",
    color: "#63b3ed",
    image: "https://images.unsplash.com/photo-1530521954074-e64f6810b32d?auto=format&fit=crop&w=430&h=140&q=80",
    places: [
      { name: "Ben Gurion Lounge", perk: "Free access + guest", dist: "At airport" },
      { name: "Priority Pass — TLV", perk: "Unlimited visits", dist: "At airport" },
      { name: "El Al Business Lounge", perk: "Food & drinks included", dist: "At airport" },
    ],
  },
  {
    id: "hotels",
    label: "Luxury Hotels",
    emoji: "🏨",
    color: "#fbbf24",
    image: "https://images.unsplash.com/photo-1542314831-068cd1dbfeeb?auto=format&fit=crop&w=430&h=140&q=80",
    places: [
      { name: "The Norman Hotel", perk: "VIP check-in + free breakfast", dist: "0.4 km" },
      { name: "Dan Tel Aviv Hotel", perk: "Late checkout + spa credit", dist: "1.9 km" },
      { name: "Brown Hotels TLV", perk: "Room upgrade if available", dist: "2.1 km" },
    ],
  },
  {
    id: "dining",
    label: "Dining & Cafés",
    emoji: "🍽️",
    color: "#f97316",
    image: "https://images.unsplash.com/photo-1414235077428-338989a2e8c0?auto=format&fit=crop&w=430&h=140&q=80",
    places: [
      { name: "Aroma Espresso Bar", perk: "10% cashback on every visit", dist: "1.1 km" },
      { name: "Benedict Restaurant", perk: "Complimentary dessert", dist: "1.5 km" },
      { name: "HaBasta Market", perk: "5% off with card", dist: "2.3 km" },
    ],
  },
  {
    id: "shopping",
    label: "Shopping",
    emoji: "🛍️",
    color: "#a78bfa",
    image: "https://images.unsplash.com/photo-1483985988355-763728e1935b?auto=format&fit=crop&w=430&h=140&q=80",
    places: [
      { name: "Dizengoff Center", perk: "Purchase protection applies", dist: "1.4 km" },
      { name: "Azrieli Mall", perk: "Extended warranty on electronics", dist: "3.2 km" },
      { name: "Sarona Market", perk: "5% stock-back", dist: "2.0 km" },
    ],
  },
  {
    id: "car",
    label: "Car Rental",
    emoji: "🚗",
    color: "#6fdc8c",
    image: "https://images.unsplash.com/photo-1555215695-3004980ad54e?auto=format&fit=crop&w=430&h=140&q=80",
    places: [
      { name: "Hertz — Ben Gurion", perk: "30% off + free upgrade", dist: "0.8 km" },
      { name: "Budget Car Rental", perk: "25% off Gold tier", dist: "1.2 km" },
      { name: "Avis Premium", perk: "Elite status + GPS free", dist: "1.6 km" },
    ],
  },
];

export default function NearbyBenefits() {
  const navigate = useNavigate();
  const [activeCategory, setActiveCategory] = useState(null);
  const [searchCity, setSearchCity] = useState("");
  const [showSearch, setShowSearch] = useState(false);

  if (activeCategory) {
    const cat = CATEGORIES.find(c => c.id === activeCategory);
    return (
      <div className="nb-page">
        <div className="nb-header">
          <button className="nb-back" type="button" onClick={() => setActiveCategory(null)}>
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#f0f2f5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <polyline points="15 18 9 12 15 6"/>
            </svg>
          </button>
          <span className="nb-title">{cat.label}</span>
          <span style={{ width: 22 }} />
        </div>

        <img src={cat.image} alt={cat.label} className="nb-cat-hero" />

        <div className="nb-places-list">
          {cat.places.map((p, i) => (
            <div className="nb-place-row" key={i}>
              <div className="nb-place-icon" style={{ background: `${cat.color}18` }}>
                <span>{cat.emoji}</span>
              </div>
              <div className="nb-place-info">
                <span className="nb-place-name">{p.name}</span>
                <span className="nb-place-perk">{p.perk}</span>
              </div>
              <div className="nb-place-right">
                <span className="nb-place-dist">{p.dist}</span>
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#9aa5be" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 18 15 12 9 6"/></svg>
              </div>
            </div>
          ))}
        </div>
        <div style={{ height: 100 }} />
      </div>
    );
  }

  return (
    <div className="nb-page">
      <div className="nb-header">
        <button className="nb-back" type="button" onClick={() => navigate("/")}>
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#f0f2f5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="15 18 9 12 15 6"/>
          </svg>
        </button>
        <span className="nb-title">Benefits Near You</span>
        <button className="nb-search-btn" type="button" onClick={() => setShowSearch(v => !v)}>
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#9aa5be" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
          </svg>
        </button>
      </div>

      {showSearch && (
        <div style={{ padding: "0 16px 12px" }}>
          <input
            className="nb-area-input"
            placeholder="Search city or area..."
            value={searchCity}
            onChange={e => setSearchCity(e.target.value)}
            autoFocus
          />
        </div>
      )}

      {/* Location context */}
      <div className="nb-location-bar">
        <svg width="12" height="12" viewBox="0 0 24 24" fill="#6fdc8c" stroke="none">
          <circle cx="12" cy="12" r="5"/>
        </svg>
        <span>Tel Aviv · {CATEGORIES.reduce((a, c) => a + c.places.length, 0)} perks found</span>
      </div>

      {/* Category cards */}
      <div className="nb-categories">
        {CATEGORIES.map(cat => (
          <button key={cat.id} className="nb-cat-card" type="button" onClick={() => setActiveCategory(cat.id)}>
            <img src={cat.image} alt={cat.label} className="nb-cat-img" />
            <div className="nb-cat-overlay" />
            <div className="nb-cat-info">
              <div>
                <span className="nb-cat-label">{cat.label}</span>
                <span className="nb-cat-count">{cat.places.length} nearby</span>
              </div>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,0.7)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 18 15 12 9 6"/></svg>
            </div>
          </button>
        ))}
      </div>
      <div style={{ height: 100 }} />
    </div>
  );
}
